import React from 'react'
import PropTypes from 'prop-types'

import classnames from 'classnames'

import Navigation from '../../containers/navigation'
import User from '../../containers/user'
import Alerts from '../../containers/alerts'
import Modals from '../../containers/modals'
import Saving from '../../containers/saving'

const Layout = (props) => {
  const { userSession, pathname } = props

  const loggedIn = userSession.loggedIn !== undefined && userSession.loggedIn !== null && userSession.loggedIn !== false
  const showUser = pathname.includes('library') || pathname.includes('event') || pathname.includes('rider')

  const className = classnames({
    layout: true,
    parallax: false
  })

  return (
    <div className={className}>
      {loggedIn ? <Navigation /> : null}
      {loggedIn && showUser ? <User /> : null}

      <Alerts />
      <Modals />
      <Saving pathname={pathname} />

      <div className="background" />

      <main>
        {props.children}
      </main>
    </div>
  )
}

Layout.propTypes = {
  userSession: PropTypes.object,
  pathname: PropTypes.string
}

Layout.defaultProps = {
  userSession: {},
  pathname: ''
}

export default Layout



// WEBPACK FOOTER //
// ./src/components/common/layout.js